import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('quick-reply-wrapper'))
  }, [
    _createElementVNode("ul", {
      "aria-label": "quick replies",
      class: _normalizeClass(_ctx.getClass('button ') + _ctx.getClass('quickReply ')  + (
            (_ctx.messageContentsettings.showOneQuickReplyPerLine !== null && _ctx.messageContentsettings.showOneQuickReplyPerLine) ?
            _ctx.getClass('singleQuickReplyPerLine ') : ' ')),
      role: "list"
    }, [
      (_ctx.isFontLoaded)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.data, (value, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(_ctx.getClass('quick-reply-item')),
              role: "listitem"
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.getClass('btn ' ) + _ctx.getClass('btnQuickReply ') + (
                    (_ctx.messageContentsettings.showOneQuickReplyPerLine !== null && _ctx.messageContentsettings.showOneQuickReplyPerLine) ?
                    _ctx.getClass('btnQuickReplyPerLine ') : ' ')),
                onClick: $event => (_ctx.onClick(index))
              }, _toDisplayString(value.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_1)
            ], 2 /* CLASS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}